import { render, staticRenderFns } from "./cancelados.vue?vue&type=template&id=5f2be67b&scoped=true&"
import script from "./cancelados.vue?vue&type=script&lang=js&"
export * from "./cancelados.vue?vue&type=script&lang=js&"
import style0 from "./cancelados.vue?vue&type=style&index=0&id=5f2be67b&scoped=true&lang=css&"
import style1 from "./cancelados.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2be67b",
  null
  
)

export default component.exports